import React from 'react'

const Icon: React.FC<any> = ({ ...props }) => {
  return (
    <svg {...props} viewBox="0 0 28 28">
      <path d="M13.8167 27.3966V0.603455 M27.3886 14.2414H0.611328" />
    </svg>
  )
}

export default Icon
